import { render, staticRenderFns } from "./schooStatic.vue?vue&type=template&id=3efbc8cf"
import script from "./schooStatic.vue?vue&type=script&lang=js"
export * from "./schooStatic.vue?vue&type=script&lang=js"
import style0 from "./schooStatic.vue?vue&type=style&index=0&id=3efbc8cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports